import { wrap } from 'src/packages/mobx-di/wrap';
import { hasValue } from 'src/packages/utils/has-value';

import type { OptionsService } from 'src/services/directory-service/options-service';
import type { TLabelView, TSimpleLabelView } from 'src/services/directory-service/types';

import styles from './label-component.module.scss';

type Props = {
  isSimpleLabel: boolean;
  fieldView: TLabelView | TSimpleLabelView;
  value: string | number | null;
  optionsService: OptionsService;
};

export const LabelComponent = wrap<Props>(function LabelComponent({ isSimpleLabel, fieldView, value, optionsService }) {
  const _value = (() => {
    if (!hasValue(value)) {
      return null;
    }

    if (isSimpleLabel) {
      return value;
    }

    return (
      optionsService.optionsMap[fieldView.fieldId].get(value)?.label ??
      optionsService.archivedOptionsMap[fieldView.fieldId].get(value)?.label
    );
  })();

  return <p className={styles.text}>{_value?.toString() ?? '-'}</p>;
});
